import React, { useContext, useState, useEffect } from "react";
import useMediaQuery from "../Hooks/useMediaQuery";
import CommunitySection from "../CommunitySection/CommunitySection";
import CommunityProgress from "../CommunitySection/CommunityProgress";
import CommunityMap from "../CommunitySection/CommunityMap";
import CommunityInfo from "../CommunitySection/CommunityInfo";
import UpdatesSection from "../UpdatesSection/UpdatesSection";
import ProfileSection from "../ProfileSection/ProfileSection";
import ChildInfo from "../ChildInfo/ChildInfo";
import EmailMeButton from "../ProfileButtons/EmailMeButton";
import GiveGiftButton from "../ProfileButtons/GiveGiftButton";
import VisitMeButton from "../ProfileButtons/VisitMeButton";
import ViewGalleryButton from "../ProfileButtons/ViewGalleryButton";
import SendMail from "../ProfileSection/SendMail";
import ChildStory from "../ProfileSection/ChildStory";
import SensitiveArea from "../ProfileSection/SensitiveArea";
import MoreWv from "../MoreWV/MoreWv";
import Login from "../ProfileSection/Login";
import SponsorBadge from "../ProfileSection/SponsorBadge";
import Group from "../AuthData/AuthGroup";
import UpdatesFeed from "../UpdatesSection/UpdatesFeed";
import StateContext from "../../state/stateContext";
import { mapChildData } from "../../helpers/helpers";
import { triggerAnalyticsEvent } from "../../helpers/analyticsHelpers";

const Layout = (props) => {
  const [allDataFetched, setAllDataFetched] = useState(false);
  const { deviceScreen } = useMediaQuery();
  const isMobile = ["x-small", "small"].includes(deviceScreen);
  const { state } = useContext(StateContext);
  const {commitment, communityNews, childInfo, expandosStatus } = state;
  const mappedData = mapChildData(childInfo.data || {});
  const childSectionCollapsedText = `View ${mappedData.hisHer} profile`;
  const communityCollapsedText = `Explore ${mappedData.hisHer} world`;

  useEffect(() => {
    const finishedStatuses = ['success', 'error'];
    if (finishedStatuses.includes(commitment.status) 
      && finishedStatuses.includes(childInfo.status) 
      && finishedStatuses.includes(communityNews.status)) 
    {
      setAllDataFetched(true);

      const timeoutId = setTimeout(() => {
        triggerAnalyticsEvent("appDataLoaded");
        clearTimeout(timeoutId);
      }, 500);
    }
  }, [commitment, communityNews, childInfo]);

  return (
    <div className="l-three-column">
      <div className="three-column__wrapper">
        <ProfileSection
          thumbnailUrl={mappedData.thumbnailUrl}
          collapsedText={childSectionCollapsedText}
          name={mappedData.name}
          isLoading={["loading", "pending"].includes(childInfo.status)}
        >
          <ChildInfo />
          <SensitiveArea />
          <Group classList="group__profile-buttons">
            <EmailMeButton />
            <GiveGiftButton />
            <VisitMeButton />
            <ViewGalleryButton />
          </Group>
          {!isMobile ? <Login /> : ""}
          <SendMail />
          <SponsorBadge />
          <ChildStory />
          <MoreWv />
          
        </ProfileSection>
        {isMobile ? (
          <>
            {!expandosStatus?.profile ? (
              <Group classList="group__profile-buttons panel__profile-buttons">
                <EmailMeButton />
                <GiveGiftButton />
              </Group>
            ) : (
              ""
            )}
            <Login />
          </>
        ) : (
          ""
        )}
        <CommunitySection collapsedText={communityCollapsedText}>
          <CommunityMap />
          <CommunityInfo />
          <CommunityProgress
            shimmerProps={{
              height: "100px",
              testId: "community-progress",
            }}
            showShimmer={["loading", "pending"].includes(childInfo.status)}
          />
        </CommunitySection>
        <UpdatesSection classList="three-column__main my-community">
          <UpdatesFeed />
        </UpdatesSection>
      </div>
    </div>
  );
};

export default Layout;